import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import DeleteIcon from '../Icons/DeleteIcon';

const Tag = ({
  children, className, onClose, type, ...others
}) => (
  <span
    className={cns(
      'tag',
      type ? (`tag--${type}`) : '',
      className,
    )}
    {...others}
  >
    {children}
    {onClose && (
      <span
        className="tag__close"
        onClick={onClose}
        role="presentation"
      >
        <DeleteIcon />
      </span>
    )}
  </span>
);

Tag.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /**
   * Callback da invocare in fase di chiusura:
   * ```
   *  onClose(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onClose: PropTypes.func,
  /** Tipo del tag, verrà aggiunta la classe tag--type al componente */
  type: PropTypes.string,
};

Tag.defaultProps = {
  children: null,
  className: '',
  onClose: null,
  type: '',
};

export default Tag;
